import { getMaskingFunctionByType, MaskingType } from '@ustra/core/src/utils/masking-utils'

export default (value: string, type: MaskingType = MaskingType.NAME): string => {
  const masking = getMaskingFunctionByType(type)

  if (!masking) {
    return value
  }

  return masking(value)
}
